import React, { useState } from 'react';
import {Stepper, StepLabel, Step, Paper, withStyles} from '@material-ui/core';
import { connect } from 'react-redux';

import * as actions from '../store/userActions';
import * as groupActions from "../../../sc-group/Group/store/groupActions";

import RoleExcluded from './NormalUser/RoleCreate';
import UserCreate from './NormalUser/UserCreate';

import ChoseCustomer from './AdminUser/ChoseCustomers';
import AdminCreate from './AdminUser/AdminCreate';
import RoleForCustomer from './AdminUser/RoleForCustomer';

import { hasPermission } from '../../../sc-utilities';


const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

const UserComponent = props => {
    const { classes, activeCustomer, translations, permissions, onFetchCustomers, onCheckFormParams, fetchGroups } = props;
    const [userFormValid, setUserFormValid] = useState(false);
    const [userFormValue, setUserFormValue] = useState({});
    const steps = [`${translations["user"] || "User "}`, `${translations["access_control"] || "Access control"}`];
    const stepsAdmin = [`${translations["user"] || "User "}`, `${translations["choose_customer"] || "Choose customer"}`, `${translations["access_control"] || "Access control"}`];
    const [customers, setCustomers] = useState([]);

    const [customersSelect, setCustomersSelect] = useState([]);

    const [activeStep, setActiveStep] = useState(0);
    const [activeStepAdmin, setActiveStepAdmin] = useState(0);

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');

    const hasAssignRoleToAllCustomersPermission = hasPermission(permissions, 'assign_role_to_all_customers');

    const getStepContentNormalUser = stepIndex => {
        switch (stepIndex) {
            case 0:
                return (<UserCreate permissions={permissions} fetchGroups={fetchGroups} onCheckFormParams={onCheckFormParams} userFormValid={userFormValid} userFormValue={userFormValue} setActiveStep={setActiveStep} setUserFormValid={setUserFormValid} translations={translations} activeCustomer={activeCustomer} setUserFormValue={setUserFormValue} />
                );
            case 1:
                return (<RoleExcluded createUser={props.onCreateUser} hasAccessAllGroupsPermission={hasAccessAllGroupsPermission} setActiveStep={setActiveStep} onLoadRoles={props.onLoadRoles} userFormValue={userFormValue} translations={translations} activeStep={activeStep} activeCustomer={activeCustomer} fetchPermission={props.fetchPermission} />);
            default:
                return 'Unknown stepIndex';
        }
    }

    const getStepContentAdminUser = stepIndex => {
        switch (stepIndex) {
            case 0:
                return (<AdminCreate permissions={permissions} fetchGroups={fetchGroups} onCheckFormParams={onCheckFormParams} onCreateUser={props.onCreateUser} userFormValid={userFormValid} setCustomers={setCustomers} onFetchCustomers={onFetchCustomers} userFormValue={userFormValue} setActiveStep={setActiveStepAdmin} setUserFormValid={setUserFormValid} translations={translations} activeCustomer={activeCustomer} setUserFormValue={setUserFormValue} />
                );
            case 1:
                return (<ChoseCustomer setUserFormValid={setUserFormValid} activeCustomer={activeCustomer} setUserFormValue={setUserFormValue} userFormValue={userFormValue} onCheckFormParams={onCheckFormParams} translations={translations} setCustomersSelect={setCustomersSelect} createUser={props.onCreateUser} customer={customers} setActiveStep={setActiveStepAdmin} onLoadRoles={props.onLoadRoles} />);
            case 2:
                return (<RoleForCustomer onCreateUser={props.onCreateUser} hasAccessAllGroupsPermission={hasAccessAllGroupsPermission} hasAssignRoleToAllCustomersPermission={hasAssignRoleToAllCustomersPermission} userFormValue={userFormValue} customers={customers} customersSelect={customersSelect} setActiveStep={setActiveStep} setActiveSteps={setActiveStepAdmin} onLoadRoles={props.onLoadRoles} translations={translations} activeStep={activeStep} activeCustomer={activeCustomer} fetchPermission={props.fetchPermission} />);
            default:
                return 'Unknown stepIndex';
        }
    }

    return (
        <Paper className={classes.root}>
            {!hasPermission(permissions, "su_user_create") ?
                <>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map(label => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <div>
                        {getStepContentNormalUser(activeStep)}
                    </div>
                </>
                :
                <>
                    <Stepper activeStep={activeStepAdmin} alternativeLabel>
                        {stepsAdmin.map(label => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <div>
                        {getStepContentAdminUser(activeStepAdmin)}
                    </div>
                </>
            }
        </Paper>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};


const mapDispatchToProps = dispatch => {
    return {
        onCreateUser: user => dispatch(actions.createUser(user)),
        onLoadRoles: user => dispatch(actions.loadRoles(user)),
        onFetchCustomers: (id) => dispatch(actions.fetchCustomers(id)),
        fetchPermission: user => dispatch(actions.fetchPermission(user)),
        onCheckFormParams: data => dispatch(actions.checkFormParams(data)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(UserComponent));